import { Image, Button } from "@chakra-ui/react";
import { onboard } from "./config";
import { useEffect } from "react";
import { useConnectWallet } from '@web3-onboard/react';
import { getEllipsisTxt } from "../../utils/formatters";

export const Connect = () => {
  const [{ wallet }, connect, disconnect] = useConnectWallet();
  const walletsSub = onboard.state.select('wallets');
  const { unsubscribe } = walletsSub.subscribe(wallets => {
    const connectedWallets = wallets.map(({ label }) => label);
    window.localStorage.setItem('connectedWallets',JSON.stringify(connectedWallets));
  })

  const handleConnectWallet = () => {
    connect();
    const state = onboard.state.get();
    state.accountCenter.enabled = false;
  }

  const handleDisconnectWallet = () => {
    disconnect(wallet);
    window.localStorage.removeItem('connectedWallets');
  }

  const connectOnLoad = async () => {
    const previouslyConnectedWallets = JSON.parse(
      window.localStorage.getItem('connectedWallets')
    )
    if (previouslyConnectedWallets) {
      connect({ autoSelect: previouslyConnectedWallets[0] });
      const state = onboard.state.get();
      state.accountCenter.enabled = false;
    }
  }

  useEffect(() => {
    if(!wallet) connectOnLoad();
    return () => {
      unsubscribe();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(wallet && wallet.chains[0].id !== "0x38") onboard.setChain({chainId: "0x38"});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wallet])
    
  return (
    <>
      {!wallet ?
        <Button onClick={handleConnectWallet} bg={"transparent"} _hover={{bg: "transparent"}} _focus={{border: "none"}} _active={{transform: "scale(.95)"}}>
          <Image alt='' width={150} src={"./images/connect.svg"} style={{cursor: "pointer"}} />        
        </Button>
        :
        <Button _hover={{bg: "#FFDA81"}} _active={{bg: "#E1B752"}} borderColor="#E1B752" variant="outline" onClick={handleDisconnectWallet}>{getEllipsisTxt(wallet.accounts[0].address)}</Button>
      }
    </>
  )
}